<template>
  <!-- chat icon (comment bubble) -->
  <svg
    width="12px"
    height="12px"
    viewBox="0 0 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>chat--sf-icon</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g fill="#FFFFFF" fill-rule="nonzero">
        <path
          class="color-background"
          d="M256,32C114.624,32,0,125.12,0,240c0,49.344,24.32,94.848,64.672,130.144C59.744,406.496,35.2,443.712,35.072,443.92
            c-3.264,5.024-3.52,11.36-0.672,16.576C36.8,465.312,41.248,468,46.016,468c66.656,0,116.672-31.104,139.776-49.024
            c22.72,5.824,46.912,9.024,70.208,9.024c141.376,0,256-93.12,256-208S397.376,32,256,32z"
        ></path>
      </g>
    </g>
  </svg>
</template>
<script></script>
